import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Sidebar from "../components/sidebar";

import Home from "../pages/home";
import Categories from "../pages/categories";
import Tournaments from "../pages/tournaments";
import Teams from "../pages/teams";
import Players from "../pages/players";
import Matches from "../pages/matches";
import TournamentsAdd from "../pages/tournamentsAdd";
import MatchesAdd from "../pages/matchesAdd";
import MatchesAddPlayer from "../pages/matchesAddPlayer";
import PlayersAdd from "../pages/playersAdd";
import TeamsAdd from "../pages/teamsAdd";
import GroundAdd from "../pages/groundAdd";
import Ground from "../pages/ground";
import Dashboard from "../pages/dashboard";
import Scoring from "../pages/scoring";

import "react-toastify/dist/ReactToastify.css";

const Navigation = () => {
    return (
        <BrowserRouter>
            <ToastContainer />
            <div className="container">
                <Sidebar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route
                            path="/dashboard/score/:id"
                            element={<Scoring />}
                        />
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/tournaments" element={<Tournaments />} />
                        <Route
                            path="/tournaments/:id"
                            element={<TournamentsAdd />}
                        />
                        <Route path="/teams" element={<Teams />} />
                        <Route path="/teams/:id" element={<TeamsAdd />} />
                        <Route path="/players" element={<Players />} />
                        <Route path="/players/:id" element={<PlayersAdd />} />
                        <Route path="/matches" element={<Matches />} />
                        <Route path="/matches/add" element={<MatchesAdd />} />
                        <Route path="/matches/:id" element={<MatchesAdd />} />
                        <Route
                            path="/teams/add/players/:teamID"
                            element={<MatchesAddPlayer />}
                        />
                        <Route path="/players/add" element={<PlayersAdd />} />
                        <Route path="/teams/add" element={<TeamsAdd />} />
                        <Route path="ground/add" element={<GroundAdd />} />
                        <Route path="/ground" element={<Ground />} />
                        <Route path="/ground/:id" element={<GroundAdd />} />
                        <Route
                            path="/tournaments/add"
                            element={<TournamentsAdd />}
                        />
                    </Routes>
                </main>
            </div>
        </BrowserRouter>
    );
};

export default Navigation;
